var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.69778 0.0407802C0.605861 0.00119196 0.504177 -0.00990055 0.405885 0.00893787C0.307592 0.0277763 0.217215 0.0756786 0.146447 0.146447C0.0756786 0.217215 0.0277763 0.307592 0.00893787 0.405885C-0.00990055 0.504177 0.00119196 0.605861 0.0407802 0.69778L6.04078 14.6978C6.08072 14.791 6.14806 14.8699 6.23387 14.9239C6.31968 14.978 6.4199 15.0047 6.52123 15.0004C6.62256 14.9962 6.72021 14.9613 6.80121 14.9002C6.88222 14.8392 6.94275 14.755 6.97478 14.6588L8.89578 8.89578L14.6588 6.97578C14.7553 6.94394 14.8399 6.88343 14.9011 6.80232C14.9624 6.72121 14.9975 6.62334 15.0017 6.52177C15.006 6.4202 14.9792 6.31976 14.9249 6.23382C14.8705 6.14789 14.7913 6.08055 14.6978 6.04078L0.69778 0.0407802Z",
    fill: "#6CC18F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.8d57784b07bad0e034ea5beed477800c.svg";
export { ForwardRef as ReactComponent };